import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
};

// First import your thunk then add thunk lifecycle handlers
export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addNotification(state, action) {
      const notice = {
        id: Date.now() + Math.floor(Math.random() * 100),
        ...action.payload,
      };
      state.notifications.push(notice);
    },
    removeNotification(state, action) {
      state.notifications = state.notifications.filter((item) => item.id !== action.payload);
    },
  },
});

// export auto-generated action creators from the reducer
export const { addNotification, removeNotification } = notificationSlice.actions;
// export the reducer to be passed to configureStore
export default notificationSlice.reducer;
